import { login, signUpOrganization } from "../auth/asyncThunks";
import {
  addMemberToOrganization,
  addNewOrganization,
  editOrganizationMemberDescription,
  fetchUserInfo,
  getOrganizationMembers,
  getUserMemberWishlistItems,
  removeItemFromWishlist,
  removeMember,
  removeOrganization,
  searchUsers,
  setActiveUserOrganization,
  setOrganizationDescription,
  setOrganizationLogo,
  setPriorityToOrganizationMembers,
  setPriorityToOrganizations,
  updateItem,
} from "./asyncThunks";

export const fetchUserInfoBuilder = (builder) => {
  builder.addCase(fetchUserInfo.pending, (state) => {
    state.fetchUserInfoPending = true;
  });
  builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
    state.fetchUserInfoPending = false;
    const { organizationUser, allUserOrganizations } = action.payload;

    state.organizationUser.id = organizationUser.id;
    state.organizationUser.email = organizationUser.email;
    state.organizationUser.phoneNumber = organizationUser.phoneNumber;
    state.organizationUser.firstName = organizationUser.firstName;
    state.organizationUser.lastName = organizationUser.lastName;
    state.organizationUser.activeOrganizationId =
      organizationUser.activeOrganizationId;
    state.organizationUser.organizationName = organizationUser.organizationName;
    state.organizationUser.organizationPhotoUrl =
      organizationUser.organizationPhotoUrl;

    state.organizationUser.description = organizationUser.description;

    state.allUserOrganizations = allUserOrganizations;
  });
  builder.addCase(fetchUserInfo.rejected, (state) => {
    state.fetchUserInfoPending = false;
  });
};

export const loginBuilder = (builder) => {
  builder.addCase(login.fulfilled, (state, action) => {
    state.loginPending = false;
    const { organizationUser, allUserOrganizations } = action.payload;

    state.organizationUser.id = organizationUser.id;
    state.organizationUser.email = organizationUser.email;
    state.organizationUser.phoneNumber = organizationUser.phoneNumber;
    state.organizationUser.firstName = organizationUser.firstName;
    state.organizationUser.lastName = organizationUser.lastName;
    state.organizationUser.activeOrganizationId =
      organizationUser.activeOrganizationId;
    state.organizationUser.organizationName = organizationUser.organizationName;
    state.organizationUser.organizationPhotoUrl =
      organizationUser.organizationPhotoUrl;
    state.organizationUser.description = organizationUser.description;

    state.allUserOrganizations = allUserOrganizations;
  });
};

export const signUpOrganizationBuilder = (builder) => {
  builder.addCase(signUpOrganization.fulfilled, (state, action) => {
    const { organizationUser, allUserOrganizations } = action.payload;

    state.organizationUser.id = organizationUser.id;
    state.organizationUser.email = organizationUser.email;
    state.organizationUser.phoneNumber = organizationUser.phoneNumber;
    state.organizationUser.firstName = organizationUser.firstName;
    state.organizationUser.lastName = organizationUser.lastName;
    state.organizationUser.activeOrganizationId =
      organizationUser.activeOrganizationId;
    state.organizationUser.organizationName = organizationUser.organizationName;
    state.organizationUser.organizationPhotoUrl =
      organizationUser.organizationPhotoUrl;
    state.organizationUser.description = organizationUser.description;

    state.allUserOrganizations = allUserOrganizations;
  });
};

export const setOrganizationDescriptionBuilder = (builder) => {
  builder.addCase(setOrganizationDescription.pending, (state) => {
    state.setOrganizationDescriptionPending = true;
  });
  builder.addCase(setOrganizationDescription.fulfilled, (state, action) => {
    state.setOrganizationDescriptionPending = false;
    const { data } = action.payload;
    const { organizationId } = action.meta.arg;

    state.allUserOrganizations = state.allUserOrganizations.map(
      (organization) =>
        organization.id === organizationId
          ? { ...organization, description: data }
          : organization
    );
    state.organizationUser.description = data;
  });
  builder.addCase(setOrganizationDescription.rejected, (state) => {
    state.setOrganizationDescriptionPending = false;
  });
};

export const setOrganizationLogoBuilder = (builder) => {
  builder.addCase(setOrganizationLogo.pending, (state) => {
    state.setOrganizationLogoPending = true;
  });
  builder.addCase(setOrganizationLogo.fulfilled, (state, action) => {
    state.setOrganizationLogoPending = false;
    const { data } = action.payload;
    const { organizationId } = action.meta.arg;

    state.allUserOrganizations = state.allUserOrganizations.map(
      (organization) =>
        organization.id === organizationId
          ? { ...organization, photoUrl: data }
          : organization
    );

    state.organizationUser.organizationPhotoUrl = data;
  });
  builder.addCase(setOrganizationLogo.rejected, (state) => {
    state.setOrganizationLogoPending = false;
  });
};

export const setActiveUserOrganizationBuilder = (builder) => {
  builder.addCase(setActiveUserOrganization.pending, (state) => {
    state.setActiveUserOrganizationPending = true;
  });
  builder.addCase(setActiveUserOrganization.fulfilled, (state, { payload }) => {
    state.setActiveUserOrganizationPending = false;
    const {
      activeOrganizationId,
      organizationName,
      organizationPhotoUrl,
      description,
    } = payload;

    state.organizationUser.activeOrganizationId = activeOrganizationId;
    state.organizationUser.organizationName = organizationName;
    state.organizationUser.description = description;
    state.organizationUser.organizationPhotoUrl = organizationPhotoUrl;
  });
  builder.addCase(setActiveUserOrganization.rejected, (state) => {
    state.setActiveUserOrganizationPending = false;
  });
};

export const getOrganizationMembersBuilder = (builder) => {
  builder.addCase(getOrganizationMembers.pending, (state) => {
    state.getOrganizationMembersPending = true;
  });
  builder.addCase(getOrganizationMembers.fulfilled, (state, { payload }) => {
    const { data, maxReached, total, page } = payload;

    if (page === 1) {
      state.organizationMembers.data = data;
    } else {
      state.organizationMembers.data = [
        ...state.organizationMembers.data,
        ...data,
      ];
    }

    state.organizationMembers.page = page;
    state.organizationMembers.maxReached = maxReached;
    state.organizationMembers.total = total;
    state.getOrganizationMembersPending = false;
  });
  builder.addCase(getOrganizationMembers.rejected, (state) => {
    state.getOrganizationMembersPending = false;
  });
};

export const searchUsersBuilder = (builder) => {
  builder.addCase(searchUsers.pending, (state) => {
    state.searchUsersPending = true;
  });
  builder.addCase(searchUsers.fulfilled, (state, { payload }) => {
    const { data, maxReached, total, page } = payload;

    if (page !== 1) {
      state.searchUsers.data = [...state.searchUsers.data, ...data];
    } else {
      state.searchUsers.data = data;
    }

    state.searchUsers.page = page;
    state.searchUsers.maxReached = maxReached;
    state.searchUsers.total = total;
    state.searchUsersPending = false;
  });
  builder.addCase(searchUsers.rejected, (state) => {
    state.searchUsersPending = false;
  });
};

export const addMemberToOrganizationBuilder = (builder) => {
  builder.addCase(addMemberToOrganization.pending, (state) => {
    state.addMemberToOrganizationPending = true;
  });
  builder.addCase(addMemberToOrganization.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.searchUsers.data = state.searchUsers.data.filter(
      (user) => user.id !== data.userId
    );
    state.organizationMembers.data = [data, ...state.organizationMembers.data];

    state.addMemberToOrganizationPending = false;
  });
  builder.addCase(addMemberToOrganization.rejected, (state) => {
    state.addMemberToOrganizationPending = false;
  });
};

export const getUserMemberWishlistItemsBuilder = (builder) => {
  builder.addCase(getUserMemberWishlistItems.pending, (state) => {
    state.getUserMemberWishlistItemsPending = true;
  });
  builder.addCase(
    getUserMemberWishlistItems.fulfilled,
    (state, { payload }) => {
      const { data } = payload;

      state.userWishlistItems = data;

      state.getUserMemberWishlistItemsPending = false;
    }
  );
  builder.addCase(getUserMemberWishlistItems.rejected, (state) => {
    state.getUserMemberWishlistItemsPending = false;
  });
};

export const removeItemFromWishlistBuilder = (builder) => {
  builder.addCase(removeItemFromWishlist.pending, (state) => {
    state.removeItemFromWishlistPending = true;
  });
  builder.addCase(removeItemFromWishlist.fulfilled, (state, { payload }) => {
    const { itemId } = payload;

    state.userWishlistItems = state.userWishlistItems.filter(
      (item) => item.id !== itemId
    );

    state.removeItemFromWishlistPending = false;
  });
  builder.addCase(removeItemFromWishlist.rejected, (state) => {
    state.removeItemFromWishlistPending = false;
  });
};

export const addNewOrganizationBuilder = (builder) => {
  builder.addCase(addNewOrganization.pending, (state) => {
    state.addNewOrganizationPending = true;
  });
  builder.addCase(addNewOrganization.fulfilled, (state, { payload }) => {
    const organization = payload.data;

    state.allUserOrganizations = [...state.allUserOrganizations, organization];

    state.addNewOrganizationPending = false;
  });
  builder.addCase(addNewOrganization.rejected, (state) => {
    state.addNewOrganizationPending = false;
  });
};

export const removeOrganizationBuilder = (builder) => {
  builder.addCase(removeOrganization.pending, (state) => {
    state.removeOrganizationPending = true;
  });
  builder.addCase(removeOrganization.fulfilled, (state, { meta }) => {
    state.allUserOrganizations = state.allUserOrganizations.filter(
      (org) => org.id !== meta.arg
    );

    state.removeOrganizationPending = false;
  });
  builder.addCase(removeOrganization.rejected, (state) => {
    state.removeOrganizationPending = false;
  });
};

export const removeMemberBuilder = (builder) => {
  builder.addCase(removeMember.pending, (state) => {
    state.removeMemberPending = true;
  });
  builder.addCase(removeMember.fulfilled, (state, { meta }) => {
    state.organizationMembers.data = state.organizationMembers.data.filter(
      (org) => org.id !== meta.arg
    );

    state.removeMemberPending = false;
  });
  builder.addCase(removeMember.rejected, (state) => {
    state.removeMemberPending = false;
  });
};

export const updateItemBuilder = (builder) => {
  builder.addCase(updateItem.pending, (state) => {
    state.updateItemPending = true;
  });
  builder.addCase(updateItem.fulfilled, (state, action) => {
    state.updateItemPending = false;
    const { data } = action.payload;

    state.userWishlistItems = state.userWishlistItems.map((item) => {
      if (item.id === data.id) {
        item = data;
      }
      return item;
    });
  });
  builder.addCase(updateItem.rejected, (state) => {
    state.updateItemPending = false;
  });
};

export const setPriorityToOrganizationMembersBuilder = (builder) => {
  builder.addCase(setPriorityToOrganizationMembers.pending, (state) => {
    state.setPriorityToOrganizationMembersPending = true;
  });
  builder.addCase(setPriorityToOrganizationMembers.fulfilled, (state) => {
    state.setPriorityToOrganizationMembersPending = false;
  });
  builder.addCase(setPriorityToOrganizationMembers.rejected, (state) => {
    state.setPriorityToOrganizationMembersPending = false;
  });
};

export const setPriorityToOrganizationsBuilder = (builder) => {
  builder.addCase(setPriorityToOrganizations.pending, (state) => {
    state.setPriorityToOrganizationsPending = true;
  });
  builder.addCase(setPriorityToOrganizations.fulfilled, (state) => {
    state.setPriorityToOrganizationsPending = false;
  });
  builder.addCase(setPriorityToOrganizations.rejected, (state) => {
    state.setPriorityToOrganizationsPending = false;
  });
};

export const editOrganizationMemberDescriptionBuilder = (builder) => {
  builder.addCase(editOrganizationMemberDescription.pending, (state) => {
    state.editOrganizationMemberDescriptionPending = true;
  });
  builder.addCase(editOrganizationMemberDescription.fulfilled, (state) => {
    state.editOrganizationMemberDescriptionPending = false;
  });
  builder.addCase(editOrganizationMemberDescription.rejected, (state) => {
    state.editOrganizationMemberDescriptionPending = false;
  });
};
